<template>
  <div class="input-confirm-container">
    <span
      class="iconfont"
      :class="inputType === 'btn' ? 'iconsearch' : 'iconFrame1'"
    ></span>

    <input
      v-model.trim="value"
      class="input"
      type="text"
      :placeholder="placeholder"
      @keyup.enter="handleEnter"
    />
    <div
      v-if="inputType === 'btn'"
      class="confirm-btn"
      @click="clickConfirm"
    >
      确认
    </div>
    <span
      v-else-if="inputType === 'enter'"
      class="iconfont icona-Frame11"
    ></span>
  </div>
</template>
<script>
export default {
  name: 'InputConfirm',
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    inputType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      value: '',
    };
  },
  methods: {
    clickConfirm() {
      if (!this.value) return this.$message.error('输入内容为空');
      this.$emit('clickConfirm', this.value);
    },
    handleEnter() {
      if (this.inputType !== 'enter') return;
      if (!this.value) return this.$message.error('输入内容为空');
      this.$emit('handleEnter', this.value);
      this.value = '';
    },
  },
};
</script>
<style lang="scss" scoped>
.input-confirm-container {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 48px;
  margin-bottom: 20px;
  padding-left: 40px;
  padding-right: 88px;
  box-sizing: border-box;
  border-radius: 8px;
  background: rgba($color: #fff, $alpha: 0.1);
  border: 1px solid transparent;
  .iconfont {
    position: absolute;
    left: 16px;
    font-size: 18px;
    font-weight: bold;
    &.iconFrame1 {
      font-weight: 400;
      font-size: 16px;
      color: #9a9ca2;
      &:hover {
        color: #ff6644;
      }
    }
    &.icona-Frame11 {
      right: 16px;
      left: auto;
      font-size: 14px;
      color: #9a9ca2;
      &:hover {
        color: #ff6644;
      }
    }
  }
  .input {
    flex: 1;
    height: 100%;
    background-color: transparent;
    border: none;
    outline: none;
    font-size: 14px;
    font-weight: 500;
    color: #fff;
  }
  .confirm-btn {
    position: absolute;
    right: 6px;
    width: 76px;
    height: 36px;
    border-radius: 6px;
    background: linear-gradient(90deg, #febe5d 0%, #e15d3f 100%);
    color: #1c212a;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &:hover {
      background: linear-gradient(90deg, #fece85 0%, #e67960 100%);
    }
  }
  &:hover,
  &:has(input:focus) {
    background-image: linear-gradient(90deg, #303336, #303336), linear-gradient(179.99998deg, #ff3d11, #ff9b19 191%);
    background-clip: padding-box, border-box;
    background-origin: padding-box, border-box;
    border: 1px solid transparent;
  }
}
</style>
